module.exports = __webpack_public_path__ + "media/src/admin/images/details_open-624ba914e013e0a4fc25fe5e0be4488c.png";